import request from '@/utils/request'
//获取话题列表
export function postTopicList(data) {
    return request({
        url: `/MemberPost/GetPostTopicList`,
        method: 'post',
        data
    })
}

//话题详情
export function postTopicInfo(data) {
    return request({
        url: `/MemberPost/GetPostTopicInfo`,
        method: 'post',
        data
    })
}

//话题详情里的动态列表
export function topicPostList(data) {
    return request({
        url: `/MemberPost/GetTopicPostList`,
        method: 'post',
        data
    })
}

//获取话题分类名称
export function postTopicCateInfo(data) {
    return request({
        url: `/MemberPost/GetPostTopicCateInfo`,
        method: 'post',
        data
    })
}

//获取话题分类
export function postTopicCateList(data) {
    return request({
        url: `/MemberPost/GetPostTopicCateList`,
        method: 'post',
        data
    })
}

//获取话题背景图列表
export function topicBgImgList(data) {
    return request({
        url: `/MemberPost/GetTopicBgImgList`,
        method: 'post',
        data
    })
}

//关闭话题
export function closeMemberTopic(data) {
    return request({
        url: `/MemberPost/CloseMemberTopic`,
        method: 'post',
        data
    })
}

//删除话题
export function deleteMemberTopic(data) {
    return request({
        url: `/MemberPost/DeleteMemberTopic`,
        method: 'post',
        data
    })
}